import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=2a968a1a"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports